export type ColumnDef<T> = {
  key: keyof T;
  regex?: RegExp;
  required?: boolean;
  error?: string;
};

export const urlRegex = new RegExp(
  "^(https?:\\/\\/)?(www\\.)?([-a-zA-Z0-9а-яА-Я]{2,256})\\.([-a-zA-Z0-9а-яА-Я]{2,4})([-a-zA-Z0-9а-яА-Я@:%_\\+.~#?&//=]*)?$",
  "gmiu"
);
export const phoneRegex = new RegExp("^\\+7\\d{10}$", "iu");
export const phoneRegexWithoutPlus = new RegExp("^7\\d{10}$", "iu");

export function validateFormData<T>(
  columns: ColumnDef<T>[],
  formData: T
): Partial<Record<keyof T, string>> {
  const errors: Partial<Record<keyof T, string>> = {};

  columns.forEach((column) => {
    if (
      column.regex &&
      (formData[column.key] as unknown as string)?.trim().length > 0 &&
      !(formData[column.key] as unknown as string)?.trim().match(column.regex)
    ) {
      errors[column.key] = column.error ?? "Неверный формат";
      return;
    }
    if (column.required && !formData[column.key]) {
      errors[column.key] = column.error ?? "Обязательное поле";
      return;
    }
    errors[column.key] = "";
  });

  return errors;
}
